module.exports = __webpack_public_path__ + "img/img.5975f085.jpg";